import React from 'react';

export interface StatusCapsuleItem {
  label: string;
  value: string | number;
  /** Tailwind color key: 'blue' | 'emerald' | 'amber' | 'red' | 'slate' | 'purple' | 'sky' */
  color?: string;
  /** If provided, the capsule becomes a clickable filter chip */
  onClick?: () => void;
  /** Whether this chip is actively filtering */
  active?: boolean;
}

const COLOR_MAP: Record<string, { bg: string; text: string; border: string }> = {
  blue:    { bg: 'bg-blue-500/10 dark:bg-blue-500/10',       text: 'text-blue-600 dark:text-blue-400',       border: 'border-blue-500/20' },
  emerald: { bg: 'bg-emerald-500/10 dark:bg-emerald-500/10', text: 'text-emerald-600 dark:text-emerald-400', border: 'border-emerald-500/20' },
  amber:   { bg: 'bg-amber-500/10 dark:bg-amber-500/10',     text: 'text-amber-600 dark:text-amber-400',     border: 'border-amber-500/20' },
  red:     { bg: 'bg-red-500/10 dark:bg-red-500/10',         text: 'text-red-600 dark:text-red-400',         border: 'border-red-500/20' },
  slate:   { bg: 'bg-slate-500/10 dark:bg-slate-500/10',     text: 'text-slate-600 dark:text-slate-400',     border: 'border-slate-500/20' },
  purple:  { bg: 'bg-purple-500/10 dark:bg-purple-500/10',   text: 'text-purple-600 dark:text-purple-400',   border: 'border-purple-500/20' },
  sky:     { bg: 'bg-sky-500/10 dark:bg-sky-500/10',         text: 'text-sky-600 dark:text-sky-400',         border: 'border-sky-500/20' },
  orange:  { bg: 'bg-orange-500/10 dark:bg-orange-500/10',   text: 'text-orange-600 dark:text-orange-400',   border: 'border-orange-500/20' },
  indigo:  { bg: 'bg-indigo-500/10 dark:bg-indigo-500/10',   text: 'text-indigo-600 dark:text-indigo-400',   border: 'border-indigo-500/20' },
  cyan:    { bg: 'bg-cyan-500/10 dark:bg-cyan-500/10',       text: 'text-cyan-600 dark:text-cyan-400',       border: 'border-cyan-500/20' },
};

const DEFAULT = COLOR_MAP.slate;

export function StatusCapsule({ label, value, color = 'slate', onClick, active }: StatusCapsuleItem) {
  const c = COLOR_MAP[color] ?? DEFAULT;
  const Tag = onClick ? 'button' : 'span';
  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 rounded border px-2.5 transition-all duration-100 ${
        c.bg} ${c.border} ${
        onClick ? 'cursor-pointer hover:brightness-95 dark:hover:brightness-110 active:scale-[0.97]' : ''
      } ${active ? 'ring-1 ring-offset-1 ring-offset-white dark:ring-offset-slate-900 ring-current shadow-sm' : ''}`}
      style={{ height: 24, fontSize: 12, fontWeight: 500 }}
    >
      <span className={`opacity-70 ${c.text}`}>{label}</span>
      <span className={`font-semibold ${c.text}`}>{value}</span>
    </Tag>
  );
}

export default StatusCapsule;
